module.exports = {"id":"229739","name":"Jacek Góralski","rating":"73","photo":"./data/images/photos/4/229739.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JacekGoralski0.json
// module id = 1859
// module chunks = 0